module.exports = __webpack_public_path__ + "img/user_logo.d5dd1e1e.png";